import script from "./FormSubscriptionCheckout.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSubscriptionCheckout.vue?vue&type=script&setup=true&lang=js"

import "./FormSubscriptionCheckout.vue?vue&type=style&index=0&id=670dd198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670dd198"]])

export default __exports__